import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigationType } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import { Toaster } from 'react-hot-toast';

function AppRoutes() {
  const location = useLocation();
  const navigationType = useNavigationType();
  const isFirstRouteRender = useRef(true);

  useEffect(() => {
    isFirstRouteRender.current = false;
  }, [location.key]);

  const transitionClass = isFirstRouteRender.current
    ? 'route-slide-none'
    : (navigationType === 'POP' ? 'route-slide-back' : 'route-slide-forward');

  return (
    <div key={location.pathname} className={`route-slide-shell ${transitionClass}`}>
      <Routes location={location}>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <div className="app-device-shell">
        <div className="app-device-frame">
          <div className="app-device-screen">
            <BrowserRouter>
              <AppRoutes />
            </BrowserRouter>
          </div>
        </div>
      </div>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#1e2a3a',
            color: '#e8edf2',
            border: '1px solid #2a3a50',
            fontFamily: "'Barlow', sans-serif",
            fontSize: '13px',
          },
          success: {
            iconTheme: { primary: '#4caf76', secondary: '#1e2a3a' }
          },
          error: {
            iconTheme: { primary: '#e05252', secondary: '#1e2a3a' }
          }
        }}
      />
    </AuthProvider>
  );
}

export default App;
